import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import logoDark from '../../assets/logo-dark.svg';
import { darkTheme } from '../../theme';
import { useMemo } from 'react';

const errorMessages = [
  {
    title: `This page doesn't exist.`,
    subtitle: `Not everything leads somewhere useful. Let's get you back to signal.`,
  },
  {
    title: `404: No page. No value.`,
    subtitle: `This path turned up empty. Happens. Let's course-correct.`,
  },
  {
    title: `The page you're looking for isn't here.`,
    subtitle: `Might've been noise. You're still in the right place for signal.`,
  },
  {
    title: `Not every move pays off.`,
    subtitle: `This page doesn't exist — but you're one click from getting back on track.`,
  },
  {
    title: `Dead end. Page not found.`,
    subtitle: `Decision-making starts with good inputs. This wasn't one. Try another.`,
  },
];

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  background-color: #1ac1ac1a;
  padding: 40px 20px;
`;

const Logo = styled.img`
  width: 160px;
  height: auto;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 24px;
  font-family: ${darkTheme.fonts.secondary};
  color: #5e84ed;
  margin-bottom: 16px;
`;

const Subtitle = styled.p`
  font-size: 14px;
  font-family: ${darkTheme.fonts.secondary};
  color: #10243e;
  margin-bottom: 32px;
  max-width: 400px;
`;

const HomeLink = styled(Link)`
  text-decoration: none;
  color: white;
  background: #5e84ed;
  padding: 12px 24px;
  border-radius: 8px;
  font-family: ${darkTheme.fonts.secondary};
  font-size: 14px;
  font-weight: bold;

  &:hover {
    background: #6a7dd6;
  }
`;

export const NotFound = () => {
  const message = useMemo(() => {
    const index = Math.floor(Math.random() * errorMessages.length);
    return errorMessages[index];
  }, []);

  return (
    <Wrapper>
      <div></div>
      <Logo src={logoDark} alt="logo" />
      <Content>
        <Title>{message.title}</Title>
        <Subtitle>{message.subtitle}</Subtitle>
        <HomeLink to="/">Go back home</HomeLink>
      </Content>
      <div></div>
      <div></div>
    </Wrapper>
  );
};
